<template>
    <div class="main-body">
        <div class="header">出库列表</div>
        <div class="out">

          <div class="search2">

            <el-button size="mini" type="primary" plain @click="showCart">新增出库</el-button>

            <div style="float:right;">
              <el-date-picker style="width:340px;" title="起止时间" size="mini"
                              v-model="startEndTime"
                              type="datetimerange"
                              value-format="yyyy-MM-dd HH:mm"
                              format="yyyy-MM-dd HH:mm"
                              range-separator="至"
                              start-placeholder="开始时间"
                              end-placeholder="结束时间">
              </el-date-picker>

              <el-button size="mini" plain style="margin-left:5px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
            </div>
            <div style="clear: both;"></div>
          </div>

            <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border>

              <el-table-column type="expand">
                <template slot-scope="scope">
                  <el-table :data="scope.row.listStockoutWaresDTO" border>
                    <el-table-column prop="waresName" label="物品名称"></el-table-column>
                    <el-table-column prop="warehouseName" label="仓库"></el-table-column>
                    <el-table-column prop="count" label="数量"></el-table-column>
                    <el-table-column prop="waresCountNow" label="库存"></el-table-column>
                  </el-table>
                </template>
              </el-table-column>

              <el-table-column prop="remarks" label="备注"></el-table-column>
              <el-table-column prop="count" label="库存"></el-table-column>
              <el-table-column prop="createTime" :formatter="timefilter" width="200" label="日期"></el-table-column>
              <el-table-column prop="Status" :formatter="statusTitle" label="状态"></el-table-column>
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <download-excel
                      class = "export-excel-wrapper"
                      :fetch           = "fetchData"
                      :fields          = "json_fields"
                      :before-generate = "startDownload"
                      :before-finish   = "finishDownload"
                      name = "出库物品.xls"
                      style="display: inline-block;margin-left: 0px;">
                    <el-button plain type="success" size="mini" icon="el-icon-download" @click="dd((scope.row))">导出</el-button>
                  </download-excel>
                </template>
              </el-table-column>
            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>



      <Cart ref="myCart" v-show="showModalCart" v-on:closeCart="showModalCart=false"
               v-on:getList="getList"></Cart>

      <div v-if="showModal" class="mask">
        <div class="lodingsIcon">
          <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
        </div>
      </div>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Cart from "./Cart";

    export default {
        name: "Page",
        data(){
            return{
                loading:false,

              showModalCart:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,


              row:null,
              showModal:false,
              json_fields: {

                "备注": "remarks",
                "总数量": "count",
                "物品": {
                  filed:"listStockoutWaresDTO",
                  callback:value=>{
                    let arr = value.listStockoutWaresDTO;
                    let str = "";
                    for(var i=0;i<arr.length;i++){
                      str += '<div>'+arr[i].waresName+'</div>';
                    }
                    return str;
                  }
                },
                "数量": {
                  filed:"listStockoutWaresDTO",
                  callback:value=>{
                    let arr = value.listStockoutWaresDTO;
                    let str = "";
                    for(var i=0;i<arr.length;i++){
                      str += '<div>'+arr[i].count+'</div>';
                    }
                    return str;
                  }
                },
                "库存": {
                  filed:"listStockoutWaresDTO",
                  callback:value=>{
                    let arr = value.listStockoutWaresDTO;
                    let str = "";
                    for(var i=0;i<arr.length;i++){
                      str += '<div>'+arr[i].waresCountNow+'</div>';
                    }
                    return str;
                  }
                },

                "仓库": {
                  filed:"listStockoutWaresDTO",
                  callback:value=>{
                    let arr = value.listStockoutWaresDTO;
                    let str = "";
                    for(var i=0;i<arr.length;i++){
                      str += '<div>'+arr[i].warehouseName+'</div>';
                    }
                    return str;
                  }
                },

                "出库时间": {
                  field:"createTime",
                  callback:value=>{
                    return timefilters(value);
                  }
                },

              },

              startEndTime:[],

            }
        },
        components:{
          Cart
        },
        created(){
          const end = new Date();
          const start = new Date(end - 1000 * 60 * 60 * 24 * 360);
          this.startEndTime = [start, end];


          this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{

          showCart(){
            this.$refs.myCart.init(this.institutionCode);
            this.showModalCart = !this.showModalCart;
          },


          timefilter(row, column, cellValue){
            return timefilters(cellValue)
          },

          current_change:function(currentPage){
              this.currentPage = currentPage;
              this.getList();
          },
          getList(){
              this.loading=true;
              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+"Stockout/Page",
                  data: {
                      timeStr:timeStr,
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      staffCode: getStaffCode(),
                      pageIndex:this.currentPage,
                      pageSize:this.pageSize,
                    startTime: timefilters(this.startEndTime[0]),
                    endTime: timefilters(this.startEndTime[1]),
                  }
              }).then( (response)=> {
                  this.loading=false;
                  if(response.data.error == 0){
                      this.tableData = response.data.data.list;
                      this.totalItems = response.data.data.total;
                  }else if(response.data.error == 1){
                      this.$message({type: 'info', message: response.data.message});
                  }
              }).catch(function (error) {
                  console.log(error);
              });
          },


          statusTitle(row){
              if(row.status == 0){
                  return "正常";
              }
              if(row.status == 1){
                  return "禁用";
              }
              return "其它";
          },


          dd(row){
            this.row = row;
          },
          fetchData(){
            let arr = [];
            arr.push(this.row);
            return arr;
          },

          startDownload:function (){
            this.showModal = true;
          },

          finishDownload:function (){
            this.showModal = false;
          },

        }
    }
</script>

<style scoped>

</style>
